// local
import { environment } from 'src/environments/environment';

// third party
import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent {
  public readonly applicationName: string = environment.applicationName;
}
